import React from "react";
import { UnoStoreHooks } from "@simulanisindia/ui";
import { ApplicationIcon } from "../../assets/Icons";
import { useModalContext } from "../../modal/context/ModalProvider";
import { useLocation, useParams } from "react-router-dom";
import { modalName } from "../../utils/general";
import apiClient from "../../apiClient";
import { ASSIGN_RESOURCE } from "../../apiClient/apiEndpoints";
import {
  ALL,
  GROUP_TAB_TYPE,
  RESOURCE_APPLICATION_TAB,
  RESOURCE_MODULE_TAB,
  RESOURCE_ENVIRONMENT_TAB,
  RESOURCE_SKILL_STREAM_TAB,
  RESOURCE_SKILL_SCHOOL_TAB,
  AR_CONTENT_TAB,
  TABS_TYPE_KEY,
  USER_TAB_TYPE,
  mappingTabWithResourceTypes,
} from "../../constant/constants";

const { useUnoSelector } = UnoStoreHooks;

const AssignButton = ({
  selectedResource,
  handleResetSelectResource,
  checkBoxAll,
  isMobileView,
  search,
  checkedFilterItem,
  locationSelectedData,
}) => {
  const { openModal, closeModal } = useModalContext();
  const configData = useUnoSelector((state) => state.config);
  const location = useLocation();
  const params = useParams();
  const { type } = params;
  let movingData = {};

  const updateResource = async () => {
    try {
      let selectedGroupUsers = location?.state?.selectedData?.items || [];
      let ids = selectedGroupUsers.map((e) => e.uuid);

      let bodyData = {
        applications: [
          ...selectedResource[RESOURCE_APPLICATION_TAB].map((e) => e.id),
        ],
        resourceIds: [
          ...selectedResource[RESOURCE_MODULE_TAB],
          ...selectedResource[RESOURCE_ENVIRONMENT_TAB],
          ...selectedResource[RESOURCE_SKILL_STREAM_TAB],
          ...selectedResource[RESOURCE_SKILL_SCHOOL_TAB],
          ...selectedResource[AR_CONTENT_TAB],
        ].map((e) => e.id),
        checkedBox: Object.keys(checkBoxAll)
          .filter((e) => checkBoxAll[e])
          .map((q) => TABS_TYPE_KEY[q]),
        ...(type === USER_TAB_TYPE && { users: ids }),
        ...(type === GROUP_TAB_TYPE && { groups: ids }),
        filter: {
          search: Object.fromEntries(
            Object.entries(search).map(([key, value]) => [
              mappingTabWithResourceTypes[key] || key,
              value,
            ])
          ),
          checkedFilterItem: Object.fromEntries(
            Object.entries(checkedFilterItem).map(([key, value]) => [
              mappingTabWithResourceTypes[key] || key,
              value,
            ])
          ),
        },
      };
      let transferData = [
        ...selectedResource[RESOURCE_APPLICATION_TAB].map(
          ({ name, avatar }) => ({ name, avatar: avatar || null })
        ),
        ...[
          ...selectedResource[RESOURCE_MODULE_TAB],
          ...selectedResource[RESOURCE_ENVIRONMENT_TAB],
          ...selectedResource[RESOURCE_SKILL_STREAM_TAB],
          ...selectedResource[RESOURCE_SKILL_SCHOOL_TAB],
          ...selectedResource[AR_CONTENT_TAB],
        ].map(({ name, avatar }) => ({ name, avatar: avatar || null })),
      ];

      movingData["transfer"] = {
        type: "user",
        data: transferData,
      };

      movingData["receiver"] = {
        type: "group",
        data: selectedGroupUsers,
      };

      openModal({
        modalName: modalName.SUCCESSFULLY_POPUP,
        message: "Assigning",
        transferring: true,
        movingData,
        modalSize: "lg",
      });
      await apiClient.post(
        `${configData.config.UNO_URL}${ASSIGN_RESOURCE}`,
        bodyData
      );
      openModal({
        modalName: modalName.SUCCESSFULLY_POPUP,
        message: `Assigned successfully.`,
        transferring: false,
        movingData,
      });
      handleResetSelectResource();
      setTimeout(() => {
        closeModal();
      }, 1000);

    } catch (error) {
      console.log(error);
    }
  };

  const handleOpenAssignModal = () => {
    openModal({
      modalName: "SHARE_RESOURCE",
      message: "Assigning",
      allCheckboxTransferKeys: checkBoxAll,
      params,
      selectedResource: {
        application: [...selectedResource[RESOURCE_APPLICATION_TAB]],
        module: [
          ...selectedResource[RESOURCE_MODULE_TAB],
          ...selectedResource[RESOURCE_ENVIRONMENT_TAB],
          ...selectedResource[RESOURCE_SKILL_STREAM_TAB],
          ...selectedResource[RESOURCE_SKILL_SCHOOL_TAB],
          ...selectedResource[AR_CONTENT_TAB],
        ],
      },
      handleResetSelectResource: handleResetSelectResource,
      checkBoxAll: checkBoxAll,
      filter: {
        search: Object.fromEntries(
          Object.entries(search).map(([key, value]) => [
            mappingTabWithResourceTypes[key] || key,
            value,
          ])
        ),
        checkedFilterItem: Object.fromEntries(
          Object.entries(checkedFilterItem).map(([key, value]) => [
            mappingTabWithResourceTypes[key] || key,
            value,
          ])
        ),
      },
    });
  };

  return (
    <>
      <button
        className={isMobileView ? "normalbtn assign" : "normalbtn"}
        disabled={Object.values(selectedResource).flat().length == 0}
        onClick={() =>
          locationSelectedData && locationSelectedData?.length > 0
            ? updateResource()
            : handleOpenAssignModal()
        }
      >
        <ApplicationIcon />
        {isMobileView ? `Assign Resoures` : "Assign"}
        {Object.values(selectedResource).flat().length > 0 && (
          <span className={isMobileView ? "count numbercount" : " count "}>
            {Object.values(selectedResource).flat().length}
          </span>
        )}
      </button>
    </>
  );
};

export default AssignButton;
